import { eventChannel } from 'redux-saga';

export default () => eventChannel(emitter => {
  window.addEventListener('beforeunload', emitter);
  return () => window.removeEventListener('beforeunload', emitter);
});
